import type { ReactNode } from "react";
import { CertificateAdminGuard } from "./CertificateAdminGuard";

/** The panel and its course editors share the same role-only access rule. */
export function InstructorPanelGuard({ children }: { children: ReactNode }) {
  return <CertificateAdminGuard>{children}</CertificateAdminGuard>;
}
